import {baseApp, websocketUrl,basePlat} from '@/utils/baseUrl.js';
const plat = basePlat; //平台
const app = baseApp; //app
let userId = sessionStorage.getItem("userid"); //当前登录用户id，
//创建链接
export default function getSocket(menu='index'){//默认主链接
	if (typeof (WebSocket)==='undefined'){
		alert('当前浏览器不支持WebSocket')
	}else{
		let socketId = new Date().getTime(); //当前时戳
		// console.log('socketId='+socketId,'menu=',menu,'userId=',sessionStorage.getItem("userid"));

		let serverUrl  =websocketUrl+"/websocket?socketId="+ socketId +"&plat="+plat+"&app="+app+"&menu="+menu+"&userId="+sessionStorage.getItem("userid"); //连接url，根据当前页面协议类型判断使用wss/ws
		// console.log('serverUrl='+serverUrl)
		let Socket=new WebSocket(serverUrl);
		Socket.onopen=()=>{
			// console.log('WebSocket连接已打开！');

		}
		Socket.onerror=()=>{
			// console.log('WebSocket连接打开失败，请检查！');
			// return null
		}

		return Socket
	}

}
